import { Contract } from '../types/entities'

export const mockContracts: Contract[] = [
  {
    id: 'ct1',
    clientId: 'c1',
    title: 'Contrato de Desenvolvimento e Manutenção – RTGuard',
    startDate: '2023-03-15',
    endDate: '2025-03-14',
    monthlyFee: 4500,
    documentUrl: 'https://drive.google.com/file/rtguard-contrato-2023',
    projectIds: ['p1', 'p2'],
    status: 'active',
    createdAt: '2023-03-15',
  },
  {
    id: 'ct2',
    clientId: 'c2',
    title: 'Contrato de Desenvolvimento – Alfa PDV',
    startDate: '2023-07-01',
    endDate: '2024-06-30',
    monthlyFee: 3200,
    projectIds: ['p3'],
    status: 'expired',
    createdAt: '2023-07-01',
  },
  {
    id: 'ct3',
    clientId: 'c2',
    title: 'Contrato de Manutenção – Alfa PDV (Renovação)',
    startDate: '2024-07-01',
    endDate: '2025-06-30',
    monthlyFee: 1800,
    documentUrl: 'https://drive.google.com/file/alfa-renovacao-2024',
    projectIds: ['p3'],
    status: 'active',
    createdAt: '2024-07-01',
  },
  {
    id: 'ct4',
    clientId: 'c3',
    title: 'Contrato de Desenvolvimento – VidaSaúde Agendamento',
    startDate: '2024-01-10',
    endDate: '2025-01-09',
    monthlyFee: 5500,
    documentUrl: 'https://drive.google.com/file/vidasaude-contrato-2024',
    projectIds: ['p4'],
    status: 'active',
    createdAt: '2024-01-10',
  },
  {
    id: 'ct5',
    clientId: 'c4',
    title: 'Contrato de Desenvolvimento – Alvorada Obras',
    startDate: '2024-04-22',
    endDate: '2025-04-21',
    monthlyFee: 6000,
    projectIds: ['p5'],
    status: 'active',
    createdAt: '2024-04-22',
  },
  {
    id: 'ct6',
    clientId: 'c5',
    title: 'Contrato de Desenvolvimento – FastMove Rastreamento',
    startDate: '2024-09-05',
    endDate: '2025-09-04',
    monthlyFee: 4800,
    documentUrl: 'https://drive.google.com/file/fastmove-contrato-2024',
    projectIds: ['p6'],
    status: 'active',
    createdAt: '2024-09-05',
  },
]
